import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, Link, useLocation } from "react-router-dom";
import { getDatabase, ref as dbRef, onValue, update, remove, push, set } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth } from "firebase/auth";
import FunctionsHeader from "../components/FunctionsHeader";
import Breadcrumb from "../components/Breadcrumb";
import SelecionarIngredientesModal from "../components/SelecionarIngredientesModal";
import { toPng } from 'html-to-image';
import axios from 'axios';
import { createCanvas, loadImage } from 'canvas';
import { FaInfoCircle, FaTrash } from 'react-icons/fa';
import IngredientNutritionalModal from "../components/IngredientNutritionalModal";

const IngredientsRoot = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-gray-200);
  font-family: var(--font-roboto);
  overflow-x: hidden;
  overflow-y: auto;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 10px; /* Reduced padding */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px; /* Adjusted max-width */
  display: flex;
  justify-content: space-between;
`;

const Column = styled.div`
  width: 32%; /* Voltar para 3 colunas */
  background-color: var(--color-white);
  border-radius: var(--br-5xs);
  padding: 15px; /* Reduced padding */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 0 5px; /* Added margin between columns */
`;

const RecipeImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: var(--br-5xs);
  margin-bottom: 10px; /* Reduced margin */
`;

const IngredientsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px; /* Reduced margin */

  th,
  td {
    border: 1px solid var(--color-gray-300);
    padding: 6px; /* Reduced padding */
    text-align: left;
  }

  th {
    background-color: var(--color-gray-100);
  }
`;

const NutritionalTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px; /* Reduced margin */
  text-align: left;
  border: 2px solid var(--color-gray-300); /* Outer border */

  th {
    font-weight: bold;
    font-size: 1.05rem; /* Increased header font size */
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .center {
    text-align: center;
    font-weight: bold;
    font-size: 1.15rem;
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .sub-header {
    font-size: 1rem;
    text-align: center;
    font-weight: normal; /* Changed font weight to normal */
    margin-bottom: 5px; /* Space between rows */
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  td {
    padding: 5px; /* Padding for table cells */
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .footer-note {
    font-size: 0.9rem;
    text-align: left;
    padding-bottom: 0px;
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .footer-note-bold {
    font-size: 0.9rem;
    font-weight: bold;
    text-align: left;
    padding-bottom: 0px;
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .client-name {
    font-size: 1rem;
    font-weight: bold;
    text-align: left;
    padding-bottom: 0px;
    border: 1px solid var(--color-gray-300); /* Inner border */
`;

const NutritionalTablePrintScreen = styled.table`
  width: 105%;
  height: 100%;
  border-collapse: collapse;
  text-align: left;
  border: 2px solid var(--color-gray-300); /* Outer border */

  th {
    font-weight: bold;
    font-size: 1.05rem; /* Increased header font size */
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .center {
    text-align: center;
    font-weight: bold;
    font-size: 1.15rem;
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .sub-header {
    font-size: 1rem;
    text-align: center;
    font-weight: normal; /* Changed font weight to normal */
    margin-bottom: 5px; /* Space between rows */
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  td {
    padding: 5px; /* Padding for table cells */
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .footer-note {
    font-size: 0.9rem;
    text-align: left;
    padding-bottom: 0px;
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .footer-note-bold {
    font-size: 0.9rem;
    font-weight: bold;
    text-align: left;
    padding-bottom: 0px;
    border: 1px solid var(--color-gray-300); /* Inner border */
  }

  .client-name {
    font-size: 1rem;
    font-weight: bold;
    text-align: left;
    padding-bottom: 0px;
    border: 1px solid var(--color-gray-300); /* Inner border */
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: black;
  color: orange;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;

  &:hover {
    background-color: #333;
  }
`;

const InputField = styled.input`
  margin: 5px 0;
  padding: 5px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 450px;
  max-width: 90%;
  max-height: 90%; /* Ensure the modal doesn't exceed the viewport height */
  overflow-y: auto; /* Enable vertical scrolling */
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const InfoBalloon = styled.div`
  background-color: #ffeb3b;
  color: #333;
  padding: 15px;
  border-left: 5px solid #fbc02d;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const PrintingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  color: white;
  font-size: 24px;
  text-align: center;
`;

const LoaderIcon = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid orange;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

const InfoIcon = styled(FaInfoCircle)`
  color: var(--color-darkorange);
  font-size: 18px;
  margin-left: 8px;
  &:hover {
    opacity: 0.8;
  }
`;

const DeleteIcon = styled(FaTrash)`
  color: #dc3545;
  font-size: 16px;
  &:hover {
    opacity: 0.8;
  }
`;

const IngredientName = styled.div`
  display: flex;
  align-items: center;
`;

// Atualize os estilos
const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

const CharacterCounter = styled.span`
  font-size: 0.8em;
  color: #999;
  margin-left: 10px;
`;

const IngredientesDaReceita = () => {
  const { recipeId } = useParams();
  const location = useLocation();
  const [recipe, setRecipe] = useState(null);
  const [ingredients, setIngredients] = useState([]);
  const [newIngredients, setNewIngredients] = useState([]);
  const [ingredientNames, setIngredientNames] = useState([]);
  const [nutritionalSummary, setNutritionalSummary] = useState({
    energy: 0,
    proteins: 0,
    carbohydrates: 0,
    dietaryFiber: 0,
    totalFats: 0,
    totalSugars: 0,
    addedSugars: 0,
    saturatedFats: 0,
    transFats: 0,
    sodium: 0,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientName, setClientName] = useState(""); // Client Name input
  const [fabricationDate, setFabricationDate] = useState(""); // Fabrication Date input
  const [expirationDate, setExpirationDate] = useState(""); // Expiration Date input
  const [showModal, setShowModal] = useState(false); // Modal visibility
  const [step, setStep] = useState(1); // Step in the modal (1 for input, 2 for confirmation)
  const [printing, setPrinting] = useState(false); // Controls the printing overlay
  const [printStatus, setPrintStatus] = useState(""); // Tracks the print status message for the user
  const [selectedIngredient, setSelectedIngredient] = useState(null);
  const [recipeName, setRecipeName] = useState(recipe?.description || "");
  const [recipeInstructions, setRecipeInstructions] = useState("");
  const [editingInstructions, setEditingInstructions] = useState(false);

  // console.log(ingredients)
  const DPI = 203; // Dots per inch para a impressora Zebra ZD220
  const LABEL_WIDTH = Math.round(80 / 25.4 * DPI); // Largura da etiqueta em pontos (80mm)
  const LABEL_HEIGHT = Math.round(70 / 25.4 * DPI); // Altura da etiqueta em pontos (70mm)

  // Define styles for the table and cells
  const tableStyle = {
    width: '100%',
    tableLayout: 'auto', // Change to 'auto' to allow columns to adjust based on content
  };

  const cellStyle = {
    wordWrap: 'break-word',
  };

  const firstColumnStyle = {
    width: '30%',
    whiteSpace: 'nowrap',
  };

  const otherColumnStyle = {
    width: '23%',
  };

  // Função para salvar no histórico de impressões
  const savePrintHistory = async (printData) => {
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
      console.error("Usuário não autenticado");
      return;
    }

    const db = getDatabase();
    const historyRef = dbRef(db, `printHistory/${user.uid}`);
    
    try {
      const historyData = {
        ...printData,
        timestamp: new Date().toISOString(),
        userId: user.uid
      };
      
      await push(historyRef, historyData);
      console.log("Dados salvos no histórico com sucesso");
    } catch (error) {
      console.error("Erro ao salvar no histórico:", error);
    }
  };

  useEffect(() => {
    const db = getDatabase();
    
    // Função para normalizar strings
    const normalizeString = (str) => {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    };
  
    // Fetch recipe details
    const recipeRef = dbRef(db, `recipes/${recipeId}`);
    onValue(recipeRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setRecipe(data);
        const ingredientsData = Array.isArray(data.ingredients) ? data.ingredients : [];
        setIngredients(ingredientsData);
        
        // Carregar instruções da receita
        setRecipeInstructions(data.instructions || "");
        
        // Map ingredient names directly from the recipe data
        const ingredientNamesMap = ingredientsData.map((ingredient) => ingredient.name);
        setIngredientNames(ingredientNamesMap);
  
        // Fetch all ingredients from the database
        const ingredientsRef = dbRef(db, `ingredients`);
        onValue(ingredientsRef, (snapshot) => {
          const allIngredients = snapshot.val();
          if (allIngredients) {
            // Calculate nutritional summary
            const nutritionalSummary = ingredientsData.reduce((summary, ingredient) => {
              // Find ingredient by exact name, normalized name, or id
              let ingredientData = Object.values(allIngredients).find(
                (ing) => ing.name === ingredient.name
              );
  
              if (!ingredientData) {
                ingredientData = Object.values(allIngredients).find(
                  (ing) => normalizeString(ing.name) === normalizeString(ingredient.name) || 
                           ing.source_id === ingredient.id
                );
              }
              
              console.log(ingredientData)
              if (ingredientData) {
                const quantityFactor = ingredient.quantity_g_or_ml / 100;
                
                summary.energy += (ingredientData.nutritionalValues.energyKcal_kcal || 0) * quantityFactor;
                summary.proteins += (ingredientData.nutritionalValues.proteins_g || 0) * quantityFactor;
                summary.carbohydrates += (ingredientData.nutritionalValues.carbohydrates_g.total_g || 0) * quantityFactor;
                summary.dietaryFiber += (ingredientData.nutritionalValues.dietaryFiber_g || 0) * quantityFactor;
                summary.totalFats += (ingredientData.nutritionalValues.fats_g.total_g || 0) * quantityFactor;
                summary.totalSugars += (ingredientData.nutritionalValues.carbohydrates_g.sugars.total_g || 0) * quantityFactor;
                summary.addedSugars += (ingredientData.nutritionalValues.carbohydrates_g.sugars.added_g || 0) * quantityFactor;
                const transValue = ingredientData.nutritionalValues.fats_g.trans_g;
                summary.transFats += (typeof transValue === 'number' ? transValue : 0) * quantityFactor;
                // Adiciona verificação específica para o sódio
                summary.sodium += (ingredientData.nutritionalValues.sodium_mg || 0) * quantityFactor;
                
                // Adiciona verificação específica para gorduras saturadas
                const saturatedValue = ingredientData.nutritionalValues.fats_g.saturated_g;
                summary.saturatedFats += (typeof saturatedValue === 'number' ? saturatedValue : 0) * quantityFactor;
              }
              return summary;
            }, {
              energy: 0,
              proteins: 0,
              carbohydrates: 0,
              dietaryFiber: 0,
              totalFats: 0,
              totalSugars: 0,
              addedSugars: 0,
              saturatedFats: 0,
              transFats: 0,
              sodium: 0,
            });
  
            setNutritionalSummary(nutritionalSummary);
          }
        });
      }
    });
  }, [recipeId]);

  useEffect(() => {
    if (recipe) {
      setRecipeName((recipe.description || "").slice(0, 50));
    }
  }, [recipe]);

  // Pré-preenchimento de dados para reimpressão
  useEffect(() => {
    if (location.state?.isReprint && location.state?.reprintData) {
      const { reprintData } = location.state;
      setClientName(reprintData.clientName || "");
      setFabricationDate(reprintData.fabricationDate || "");
      setExpirationDate(reprintData.expirationDate || "");
      setModalPortionSize(reprintData.portionSize || portionSize);
      setAllergensText(reprintData.allergensText || "NÃO CONTÉM GLÚTEN/ CONTÉM LACTOSE.<br>ALÉRGICOS: PODE CONTER TRAÇOS DE GLÚTEN.");
      setEditableIngredients(reprintData.ingredients || "");
      setRecipeName(reprintData.recipeName || "");
    }
  }, [location.state]);

  // Calculate portionSize as the sum of all ingredient quantities
  const calculatePortionSize = (ingredients) => {
    if (!Array.isArray(ingredients)) {
      return 0;
    }
    return ingredients.reduce((total, ingredient) => {
      const quantity = parseFloat(ingredient.quantity_g_or_ml);
      return total + (isNaN(quantity) ? 0 : quantity);
    }, 0);
  };

  const [portionSize, setPortionSize] = useState(calculatePortionSize(ingredients));
  const [modalPortionSize, setModalPortionSize] = useState(portionSize);
  const [allergensText, setAllergensText] = useState("NÃO CONTÉM GLÚTEN/ CONTÉM LACTOSE.<br>ALÉRGICOS: PODE CONTER TRAÇOS DE GLÚTEN.");
  const [editableIngredients, setEditableIngredients] = useState(
    Array.isArray(ingredients) && ingredients
      .sort((a, b) => Number(b.quantity_g_or_ml) - Number(a.quantity_g_or_ml))
      .map(ingredient => ingredient.name)
      .join(', ')
  );

  // Update portionSize whenever ingredients change
  useEffect(() => {
    setPortionSize(calculatePortionSize(ingredients));
    setEditableIngredients(
      Array.isArray(ingredients) && ingredients
        .sort((a, b) => Number(b.quantity_g_or_ml) - Number(a.quantity_g_or_ml))
        .map(ingredient => ingredient.name)
        .join(', ')
    );
  }, [ingredients]);

  // Function to handle opening the modal
  const openModal = () => {
    setShowModal(true);
    setStep(1); // Start at step 1
  };

  // Função para salvar as instruções da receita
  const saveRecipeInstructions = async () => {
    if (!recipeId) return;
    
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      const database = getDatabase();
      
      if (!user) {
        alert("Usuário não autenticado");
        return;
      }
      
      const recipeRef = dbRef(database, `recipes/${user.uid}/${recipeId}/instructions`);
      await set(recipeRef, recipeInstructions);
      setEditingInstructions(false);
      console.log("Instruções da receita salvas com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar instruções da receita:", error);
      alert("Erro ao salvar instruções. Tente novamente.");
    }
  };

  // Function to handle moving to step 2 (confirmation)
  const handleAdvance = () => {
    if (clientName && fabricationDate && expirationDate) {
      setStep(2);
    } else {
      alert("Todos os campos devem ser preenchidos.");
    }
  };

  // Function to go back to step 1
  const handleGoBack = () => {
    setStep(1);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    // Ajusta a data para o fuso horário local
    const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    return adjustedDate.toLocaleDateString("pt-BR"); // Formats the date as dd/mm/yyyy
};

  // Adicione esta função de formatação
  const formatNumberWithComma = (value) => {
    if (!value) return '0';
    return value.toString().replace('.', ',');
  };

  // Função para gerar o ZPL da tabela nutricional ajustado para a etiqueta de 80x70mm
  // const generateZPL = () => {
  //   return "^XA^FO0,0^GFA,37518,37518,78,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,L07mLF8,L07mLF8,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01002804K04L01M04L01K039089008L02M08L02M08L02M08J04R08N08J04J02J018,L06Q0103FF84K04L01M04L01K01A956808L02M08L02M08L02M08J04R08N08J04J02J018,L06Q010682C4K04L01M04L01K012E44808L02M08L02M08L02M08J04R08N08J04J02J018,L06Q010C0064K04L01M04L01K039984808L02M08L02M08L02M08J04R08N08J04J02J018,L06Q011I014K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01002004K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q0100F204K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01019304K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q010I104K04L01M04L01R08L02M08L02M08L02M08J04R08I0EJ08J04J02J018,L06Q010I104K04L01M04L01R08L02M08L02M08L02M08J04R08I02J08J04J02J018,L06Q01019304K04L01M04L01R08L02M08L02M08L02M08J04R0802FK08J04J02J018,L06Q0100FE04K04L01M04L01R08L02M08L02M08L02M08J04R080318J08J04J02J018,L06Q01007404K04L01M04L01R08L02M08L02M08L02M08J040048N080404J08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J0403FCN080404J08J04J02J018,L06Q010A5504K04L01M04L01R08L02M08L02M08L02M08J040202N080404I088J04J02J018,L06Q010IF04K04L01M04L01R08L02M08L02M08L02M08J040202N08060C00388J04J02J018,L06Q01018204K04L01M04L01R08L02M08L02M08L02M08J040306N0803F801E08J04J02J018,L06Q0101030402I04L01M04L01R08L02M08L02M08L02M08J0401FCN0800800F208J04J02J018,L06Q0101010406I04L01M04L01R08L02M08L02J04008L02M08J04009O0800200C208J04J02J018,L06Q0101830403E004L01M04L01R08L02M08L02I03E008L02M08J04002O0801F807A08J04J02J018,L06Q0100FE0417C004L01M04L01R08L02M08L02I022008L02M08J0403FCN08060800E08J04J02J018,L06Q010068041FC004L01M04L01R08L02M08L0200C22008L02M08J040202N08040400388J04J02J018,L06Q01K040BC004L01M04L01R08L02M08L020033E008L02M08J040202N080404J08J04J02J018,L06Q01005504076004L01M04L01R08L02M08L020018I08L02M08J040306N080404I088J04J02J018,L06Q0100FF04064004L01M04L01R08L02M08L0200E6I08L02M08J0401FCN0807FCI088J04J02J018,L06J0EL01019204K04L01M04L01R08L02M08L0201B18008L02M08J0400AO080554I088J04J02J018,L06I01F8K0101130403F804L01M04L01R08L02M08L020110C008L02M08J04R08M088J04J02J018,L06J0B8K010I10407FE04L01M04L01R08L02M08L0201BJ08L02M08J0401FCN0802480AA88J04J02J018,L06Q01019B040F2E04L01M04L01R08L02M08L0200EJ08L02M08J040306N0807FC0FF88J04J02J018,L06003FCL0100CE040C0704L01M04L01R08L02M08L02M08L02M08J040202N08N08J04J02J018,L0600FFCL01I0404180304L01M04L01R08L02M08L02M08L02M08J040202N08040401C08J04J02J018,L0600FFCL01K04180304L01M04L01R08L02M08L0201FFE008L02M08J040396N08060407708J04J02J018,L0601C8CL010BAB04180304L01M04L01R08L02M08L020094E008L02M08J0400F80128J0807840C188J04J02J018,L06019CEL010EFE041F7704L01M04L01R08L02M08L02I038008L02M08J04K01FCJ0804C408088J04J02J018,L0601ICL010183041IF04L01M04L01R08L02M08L02I07I08L02M08J040182I04J08046408088J04J02J018,L0600EDCL010101041IB04L01M04L01R08L02M08L02001CI08L02M08J040362I04J08041C0C188J04J02J018,L0600EFCL01010104K04L01M04L01R08L02M08L02003J08L02M08J040232I0CJ08040C06B08J04J02J018,L0600678L010187041CI04L01M04L01R08L02M08L0200EJ08L02M08J04020A01F8J08K03C08J04J02J018,L06Q0100FE041FI04L01M04L01R08L02M08L0201FFE008L02M08J04030EN0800EK08J04J02J018,L060A554L010010040FE004L01M04L01R08L02M08L0201DB6008L02M08J040182007K0803B804708J04J02J018,L061IFCL01K0401FC04L01M04L01R08L02M08L02M08L02M08J04K01D8J08060C0FD88J04J02J018,L061IFCL01056D04003F04I03801J0E004I03801L07K08I07002I01C008I07002M08I07002I01C008J04K0104J0804040J8J04J02J018,L0601C2CL010DFF04I0F04I06C01I01B004I06C01L0D8J08I0D802I036008I0D802001FE008I0D802I036008J04K0104J0804040J8J04J02J018,L0601C0EL01K04007F040104401004110040104401J02088J080208802008220080208802003EC008020880200822008J04K0184J08060C0J8J04J02J018,L060180CL01K0403F80400C6C010031B00400C6C01J018D8J08018D80200636008018D80200224008018D80200636008J04003I0F80018803580FF88J04J02J018,L0601C0EL0100D5040FE00400638010018E0040063801K0C7K0800C70020031C00800C700200I200800C70020031C008J0400F6005K0801E00AA08J04J02J018,L0600F7CL0101FF041FI040018001I06I040018001K03L08003I02I0CI08003I0200326008003I02I0CI08J040092L0108M088J04J02J018,L0600FF8L0101I0418I0403E600100F9800403E6001J07CCK0807CC00201F3I0807CC002001B600807CC00201F3I08J040092K0378803180J8J04J02J018,L06003FM0101I04K040221801008860040221801J0443K0804430020110C0080443002I09C00804430020110C008J0400D6K02488060C0J8J04J02J018,L0618O0101I04K04022I010088I04022I01J044L08044I02011J08044I02M08044I02011J08J04007CK0248804040J8J04J02J018,L061D554L0101DB04K0403EI0100F8I0403EI01J07CL0807CI0201FJ0807CI02M0807CI0201FJ08J04L0980358804040J8J04J02J018,L061CFFCL0101FF04K04L01M04L01R08L02M08L0201FFE008L02M08J04024801AC01908060C0DD88J04J02J018,L0607FFCL01K04K04L01M04L01R08L02M08L020155E008L02M08J0407FE0124J0803280F788J04J02J018,L060012M01K04001F0400FE001003F800400FE001J01FCK08L02007FI0801FC002I01C008L02007FI08J040082016400A8801FK08J04J02J018,L06Q0101FF04003F0401D78010075E00401D7801J03AFK08L0200EBC00803AF002I07I08L0200EBC008J04008201CC03F88K02208J04J02J018,L06007FM010096040431040300C0100C030040300C01J06018J08056D802018060080601802001CI08056D80201806008J0400C6K02488K0E308J04J02J018,L0600FF8L01I01040F37040200401008010040200401J04008J0807FF8020100200804008020038I0807FF80201002008J04007C002002488K08088J04J02J018,L0600EBCL01I010403DF040200C01008030040200C01J04018J0802J0201006008040180200EJ0802J0201006008J04001001EC03688K08088J04J02J018,L0600C0CL01I0304017A040343C0100D0F0040343C01J06878J0803J0201A1E008068780201EDA00803J0201A1E008J04K012401308I0C08088J04J02J018,L060180CL0101FF040FF00401FF001007FC00401FF001J03FEK0801J0200FF800803FE00201FFE00801J0200FF8008J04K0124J08I030C308J04J02J018,L0601C0CL0101B8041F9C04001I01I04I04001I01K02L08L02I08I08002I02M08L02I08I08J04K01AC01108I0407F08J04J02J018,L0601C1CL01K0418CE04L01M04L01R08L02M08L02M08L02M08J04I0200F803188001CJ08J04J02J018,L0600FFCL01K04198204L01M04L01R08L02M08L02M08L02M08I04400FE00200208800FK08J04J02J018,L06007F8L01K041F8004L01M04L01R08L02M08L02M08L02M08I044009401I02088079K08J04J02J018,L06003DM01K0406I04L01M04L01R08L02M08L02M08L02M08J040092018003388061K08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M080070400D201FC01E0803DK08J04J02J018,L060D6DCL01K07jKF801D84005EN08007I01E8J04J02J018,L060IFCL01K04K04L01M04L01R08L02M08L02M08L02M0801044L0200BF88001CJ08J04J02J018,L060IFCL01K04K04L01M04L01R08L02M08L02M08L02M0801044008200F80AA88I0400A88J04J02J018,L060FCN010IF04K04L01M04L01R08L02M08L02M08L02M08018440192018CJ08004003F88J04J02J018,L0603F8M010I504K04L01M04L01R08L02M08L02M08L02M0800F8403FE01040208807FC02488J04J02J018,L06007EM0106I04K04L01M04L01R08L02M08L02M08L02M0800504008001040FF88004002488J04J02J018,L06001FCL0106I04K04L01M04L01R08L02M08L02M08L02M08J04001001AC06408004003688J04J02J018,L06I03CL01K04K04L01M04L01R08L02M08L02M08L02M0808FC400F6007002008004001308J04J02J018,L06I0FCL01K04K04L01M04L01R08L02M08L02M08L02M0805A840092K01D08004K08J04J02J018,L06003FM01180034K04L01M04L01R08L02M08L02M08L02M080D244009205EC13488056803E88J04J02J018,L0601FCM010C0064K04L01M04L01R08L02M08L02M08L02M080924400D605541A48807FC02B88J04J02J018,L060FEN010757C4K04L01M04L01R08L02M08L02M08L02M0805BC4007CK02488M088J04J02J018,L060FDECL0101FE04K04L01M04L01R08L02M08L02M08L02M0800104002800FC03508004J088J04J02J018,L060IFCL01K04K04L01M04L01R08L02M08L02M08L02M08J0402I01AC00F0807FC02588J04J02J018,L060IFCL01K04K04L01M04L01R08L02M08L02M08L02M08018C402FE0124J08001803F08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M080105CK012403FE8003K08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M080106C004001B4035B800E002008J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08018C407FE009802098018003008J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M0800F840086K02098075403F88J04J02J018,L06Q0101578403FFC4L01M04L01R08L02M08L02M08L02M0800204008200FC031B807FCJ08J04J02J018,L06Q0101FEC403FFE4L01M04L01R08L02M08L02M08L02M08010040082019001F28K01108J04J02J018,L06003C8L0101836401A7E4L01M04L01R08L02M08L02M08L02M080180400FC01I02008K03188J04J02J018,L0600F98L01010124030334L01M04L01R08L02M08L02M08L02M0801FC4002801I0200807FC02088J04J02J018,L0600FDCL01010124030334L01M04L01R08L02M08L02M08L02M08J04L0FC03208024802088J04J02J018,L0601ICL0101A764038334L01M04L01R08L02M08L02M08L02M0800204K01A803F88K03188J04J02J018,L06019CEL0100FE4401FF64L01M04L01R08L02M08L02M08L02M0800F84K01L08038C01F08J04J02J018,L0601ICL0100100401FE64L01M04L01R08L02M08L02M08L02M08018C4K01I01D0806D8J08J04J02J018,L0600DDCL01K04003004L01M04L01R08L02M08L02M08L02M0801044007E019003488046K08J04J02J018,L0600FF8L0103F804014404L01M04L01R08L02M08L02M08L02M080104400D601FC02488044K08J04J02J018,L06007F8L01075E040FFE04L01M04L01R08L02M08L02M08L02M0801C840092K02488044K08J04J02J018,L060012M010C03041IF04L01M04L01R08L02M08L02M08L02M08007840092K0350807FCI088J04J02J018,L06I044L010801041C0304L01M04L01R08L02M08L02M08L02M08J0400DAL0F080554I0E8J04J02J018,L0600FFCL01080304180384L01M04L01R08L02M08L02M08L02M0800F84004CN08N08J04J02J018,L0600FFCL010D1704180304008040100CJ040055001K0AAK08I04002M0800AA002002A8008010080200228008018C4K01I01F88023801F88J04J02J018,L0601E5M0107FC041E4F0401F040100EJ0401FF801J03FFK0806AD002M0803FF00200FFC00803E080200F7C00801044007E01I0350807EC03588J04J02J018,L06018N010048040IF04031840100BCI040300C01J06018J0807FF802004040080601802018060080630802019C60080104400C801FC020080I402488J04J02J018,L0601CN01K0407FC04020C4010087I040200401J04008J08030400201FFE00804008020100200804188020108200801DD4008I088020080I402488J04J02J018,L0600CN01087E04K0402064010081E0040200401J04008J0801C400200A52008040080201002008040C8020108200801BBC008I020031080I403688J04J02J018,L0601FFCL0108E704083C040303C01008030040300C01J06018J08007400200CJ08060180201806008060780201886008J04007E01EC03F8807FC01308J04J02J018,L0600FFCL010C810418FE0401C0C01008J0401FF801J03FFK08001C002004J0803FF00200FFC008038180200C0C008J0400D40124J080554J08J04J02J018,L06016D8L0108C10418F7040080401008J04005A001K0B4K08I0C002M0800B4002002DI08010080200408008J040080012401C08K01308J04J02J018,L06008N010C830419C304L01M04L01R08L02M08L02M08L02M08J04008001AC0358802F003588J04J02J018,L0601CN010FC60418C384J0E01J03804J0E01L01CJ08I01C02J07008I01C02J07008I01C02J070080054400C400F802488031802488J04J02J018,L0600CN0101440419C304J0B01J02C04J0B01L016J08I01602J05808I01602J05808I01602J0580801FC400FE004002488040402C88J04J02J018,L0601EB4L01K041FC704L01M04L01R08L02M08L02M08L02M0801244L01003D88040403988J04J02J018,L0600FFCL01K041FCE04I02001001540040055001K0AAK0800AA002002A800800AA002002A800800AA002002A80080124400FA01BC00E080404J08J04J02J018,L0601FFCL01030104004C040356801007FE00401FF801J03FFK0803FF00200FFC00803FF00200FFC00803FF00200FFC00801B4400AE0124J08060C01108J04J02J018,L06Q010FC104K0403FFC0100C030040300C01J06018J0806018020180600806018020180600806018020180600800984I020124J0803F81FF88J04J02J018,L06Q010C71040203040182001008010040200401J04008J08040080201002008040080201002008040080201002008J04I0201ECJ08004K08J04J02J018,L06007FCL010819040F830400E2001008010040200401J04008J0804008020100200804008020100200804008020100200809AC4004A0088J08M088I044J02J018,L0600FFCL01080D041FE304003A00100C030040300C01J06018J080601802018060080601802018060080601802018060080F78400FCK0130803B803F88I044J02J018,L0600FFCL010C07041CF304I0E001007FE00401FF801J03FFK0803FF00200FFC00803FF00200FFC00803FF00200FFC008J04O0368806CC02508J04J02J018,L0601C8CL01060304183B04I0600100168004005A001K0B4K0800B4002002DI0800B4002002DI0800B4002002DI0800E04O024880I4024880J4J02J018,L06019CCL0101I04181F04L01M04L01R08L02M08L02M08L02M0801AC4O024880I4034880J4J02J018,L0601ICL01K041C0F04L01M04L01R08L02M08L02M08L02M0801244L0B40398804CC017880J4J02J018,L0600EFCL01K040F0704L01M04L01R08L02M08L02M08L02M0801244002401EC0090807FCJ080J4J02J018,L0600EFCL01K04060304L01M04L01R08L02M08L02M08L02M0801A8400FE01J0408K0420806D44J02J018,L0600238L01K04K04L01M04L01R08L02M08L02M08L02M0800784008001I03D88I040678807FC4J02J018,L06Q01002004K04L01M04L01R08L02M08L02M08L02M08J04008I0A402488003C08C88J04J02J018,L060386M0100F207jKF800F84004801FC0248800F00J801384J02J018,L0607878L01019304K04L01M04L01R08L02M08L02M08L02M08018C400FE01I03588079009I8076C4J02J018,L060F87CL010I104K04L01M04L01R08L02M08L02M08L02M0801044008001I01F0806100D1880J4J02J018,L060E00CL010I104K04L01M04L01R08L02M08L02M08L02M0801044008001J040801D0063080J4J02J018,L060C00EL01019304K04L01M04L01R08L02M08L02M08L02M080194C008001FC010080078J0804C44J02J018,L060C00CL0100FE04K04L01M04L01R08L02M08L02M08L02M0801FFC00FE00801FF88I0CJ0807884J02J018,L060C00EL01007404K04L01M04L01R08L02M08L02M08L02M08J04004I06002188N0801184J02J018,L060E01CL01K04K04L01M04L01R08L02M08L02M08L02M08J04001001EC02088N08J04J02J018,L0607ABCL010A5404K04L01M04L01R08L02M08L02M08L02M08J040076012402088L01C800E04J02J018,L0607FF8L010IF04K04L01M04L01R08L02M08L02M08L02M08J040092012403F08M06803B84J02J018,L0601FFM01018304K04L01M04L01R08L02M08L02M08L02M0800104009201AC00A08I0E01C08060C4J02J018,L06001N01010104K04L01M04L01R08L02M08L02M08L02M0801BC400D600F8J08I030770804044J02J018,L06Q01010104K04L01M04L01R08L02M08L02M08L02M0801244007CK01F8800E00C18804044J02J018,L06Q01018304K04L01M04L01R08L02M08L02M08L02M0801244001004900350803B808088060C4J02J018,L06Q0100FE04K04L01M04L01R08L02M08L02M08L02M0801EC4K0FFC02488060C0808803B84J02J018,L06N07901006804K04L01M04L01R08L02M08L02M08L02M0800884K01040248804040C18801604J02J018,L06M01F301K04K04L01M04L01R08L02M08L02M08L02M08J04K01040378804040770804004J02J018,L060CK01FB81K04K04L01M04L01R08L02M08L02M08L02M0800F840030018C00108060C02C0804004J02J018,L060FK0399C1K0403FF84L01M04L01R08L02M08L02M08L02M08018C400F600F8J0803B8J0804004J02J018,L060FEJ033981K0403FFE4L01M04L01R08L02M08L02M08L02M08010440092J01FF88016003C0807FC4J02J018,L0601F8I039981K0401D7E4L01M04L01R08L02M08L02M08L02M08010440092007013288K06B0805244J02J018,L06003FI01BB81006804030374L01M04L01R08L02M08L02M08L02M08018C400D601D80208803F00C18804004J02J018,L06I0FE001FF8100FE04030334L01M04L01R08L02M08L02M08L02M0800F84007C01040208803180808804004J02J018,L06I01EI0FF01018304030334L01M04L01R08L02M08L02M08L02M08J04K010403388040408088J04J02J018,L06J03I0280101010403EF74L01M04L01R08L02M08L02M08L02M0804904I08018401E0804040D58801104J02J018,L060063M0101010401FE64L01M04L01R08L02M08L02M08L02M080FFC400DE00F8J0804040FF8807184J02J018,L0600F3CL01018304007804L01M04L01R08L02M08L02M08L02M0801044009200500BF8807ACJ0804044J02J018,L0600E1CL0100EE04K04L01M04L01R08L02M08L02M08L02M08010440092K0AA8806FCJ0804044J02J018,L0601C0CL01007C0407FC04L01M04L01R08L02M08L02M08L02M08010C400F600F8J08K0FF8804044J02J018,L060180EL01K040IF04L01M04L01R08L02M08L02M08L02M0801F840044018C01308I0C09208061C4J02J018,L0601C0CI01101K041E9704L01M04L01R08L02M08L02M08L02M0800204K0104035880078I08803F04J02J018,L0600E5CI0FF8108FF04180304L01M04L01R08L02M08L02M08L02M08J04007E01040248801D00C088J04J02J018,L0600FFC001FF810DD60418038403J01J080040054001K0A8K08J0802002AI0800A8002002AI08L02M0805FC400D601D482C8806100E088I0C4J02J018,L06007FI03BB81051204180304038I01007BE00401FF801J03FFK0803E080200FFC00803FF00200FFC008L02M08J04009201BF8398807100BI800784J02J018,L06I04I0391810911041FEF0402FI0100DE70040301C01J06038J0806B08020180E00806038020180E008L02M08008840092N0801F008C8801D04J02J018,L06M0339810D93040FFE04021C001008410040200401J04008J0804188020100200804008020100200807FF80201FFE008018C400DAL0108003C0878806104J02J018,L06M0399C104DF040274040207801008410040200401J04008J08040C80201002008040080201002008035500200D5400801044004CK03788I040818807104J02J018,L06M01DF810044040080040201C0100C430040300C01J06018J0806068020180600806018020180600802J02008J0801044O02488I08I08801F04J02J018,L06M01DF01K040FFE0402J010040600401FB801J03F7K08020380200FDC00803F700200FDC00803J0200CJ08018C4007C009802488037801408003C4J02J018,L06N0450100C6040IF0402J010060400400DE001J01BCK080380802006FI0801BC002006FI08L02M0800F8400C601B403588064407F08I044J02J018,L060015400380010183041C0B04L01M04L01R08L02M08L02M08L02M08J0400820124019080I40C188I044J02J018,L0600FFC00380010101E4180384J0401J02004J0401M08J08J0802J02008J0802J02008J0802J020080060400820164J08040408088I044J02J018,L0600FFC00191010101A4180304J0F01J03C04J0F01L01EJ08I01E02J07808I01E02J07808I01E02J0780801EC404EE01CC01D08060C08088I044J02J018,L0601DDC003FF810183041C0704J0101K0404J0101M02J08J0202K0808J0202K0808J0202K08080124407DCI080348803280C188I044J02J018,L0601C8C003FF8100D6041IF04L01M04L01R08L02M08L02M08L02M0801244L0200248801F00650801244J02J018,L06019CC0012501007C0407FE04L01007FC00401FF001J03FEK0803FE00200FF800803FE00200FF800803FE00200FF800801AC4L0F802488K03E0807FC4J02J018,L0601EDCL01K04015004L0100E9600403A5801J074BK08074B00201D2C008074B00201D2C008074B00201D2C00800F84K018C0350800AK08J04I082J018,L0600EFC0016D81018004K04036D801008030040200C01J04018J08040180201006008040180201006008040180201006008J04K010401F0803F802208J04I082J018,L060067C003FF8101I04K0403FFC01008010040200401J04008J0804008020100200804008020100200804008020100200800FC400260104J08060C0E308J0403FE2J018,L06I02I03FF8101D504K0401J01008030040200C01J04018J0804018020100600804018020100600804018020100600801A8400FC01AC01108040408088J0401882J018,L06O018101FF0416BA04018I0100EAE00403AB801J0757K08075700201D5C008075700201D5C008075700201D5C00801004008I07003188040408088J0400C82J018,L061IFCJ0181K041IF04008I01003FC00400FF001J01FEK0801FE002007F800801FE002007F800801FE002007F800801004008L02088060C0808807A8400382J018,L061IFCJ01C10010041FDF04L01M04L01R08L02M08L02M08L02M0801904005205FC0308803280C308077C400182J018,L060BEBC002AB81007E040CI04L01M04L01R08L02M08L02M08L02M0801FC400FE055401F0801F007F0803804J02J018,L060080C001FF8101CA040CI04L01M04L01R08L02M08L02M08L02M08J04008M0408N0800E0401822J018,L0601C0C003FF0101030406I04L01M04L01R08L02M08L02M08L02M0801004008001J0808044K08001C403622J018,L0601C0EL01010104K04L01M04L01R08L02M08L02M08L02M08018040080018003D88044K08001C402322J018,L0600EBCI02801010104K04L01M04L01R08L02M08L02M08L02M0801FC400FE01FC02488044K0800704020A2J018,L0600FFCI0FE01018607jKF8J04M0402488044J08803804030E2J018,L06007FI01FF0100FE04K04L01M04L01R08L02M08L02M08L02M0800704003800200358807F4I0E806E8401822J018,L06M01C781001004K04L01M04L01R08L02M08L02M08L02M0801D8400EC09FC01F0806DCJ0807BC4J02J018,L06I094003818101I04K04L01M04L01R08L02M08L02M08L02M08010440082092800208K04A88J0400902J018,L0600FFC00301C107C004K04L01M04L01R08L02M08L02M08L02M08010440082052400I80I40FF880J403FE2J018,L0600FFC00381810CE004K04L01M04L01R08L02M08L02M08L02M080184400C201A403F880I40E0082J402022J018,L0600DDC001C3810C2004K04L01M04L01R08L02M08L02M08L02M0800F84007C00BC020080I401C082J402022J018,L0601C8C001FF81082004K04L01M04L01R08L02M08L02M08L02M08005040028K020080I4007081J403062J018,L06019CEI0FF01082004K04L01M04L01R08L02M08L02M08L02M0809004K04200300806D40018806D4401FC2J018,L0601ICI02801082004K04L01M04L01R08L02M08L02M08L02M080900400C605FC03F8807FC00F0807FC400402J018,L0600EFCJ02010EF604K04L01M04L01R08L02M08L02M08L02M080FFC40082N08K03008J04I022J018,L0600EFC001FF810IF04K04L01M04L01R08L02M08L02M08L02M0801084008202L0801040EA880400401E22J018,L06I028001FF81K04K04L01M04L01R08L02M08L02M08L02M08J0400C60FFCJ08079C0FF880400403322J018,L060028I03D281K04K04L01M04L01R08L02M08L02M08L02M08J04007C010CJ08047K080400402122J018,L06007D8003I010EI04K04L01M04L01R08L02M08L02M08L02M08J04001001040010804400808807FC4020E2J018,L0600FDC0038001038004K04L01M04L01R08L02M08L02M08L02M08J04K01040378804400J80400403862J018,L0601D8C001800100F004K04L01M04L01R08L02M08L02M08L02M0800104K01F80248806D40J80400400802J018,L0601CCE003FF81001E04K04L01M04L01R08L02M08L02M08L02M0801BC4L0500248807FC0J804004J02J018,L06019CC001FF81I0384K04L01M04L01R08L02M08L02M08L02M0801244I02K03588K0A988J0403002J018,L0601CDC0035B01K04K04L01M04L01R08L02M08L02M08L02M0801244007EK01908K0FF8807F8400E02J018,L0600FFCL01K04K04L01M04L01R08L02M08L02M08L02M0801EC400D4N08N08055C4001C2J018,L06007F8I0F9010IF04K04L01M04L01R08L02M08L02M08L02M08008840092L0A88N0800184I072J018,L06002EI01F3810IA04K04L01M04L01R08L02M08I08002M08L02M08J040092009803F88I0806F0800604J02J018,L06M01F981K04K04L01M04L01R08L02M0800FF802M08L02M0800F8400DE01AC02488I070CA8801C0401F82J018,L06005B400399C1005504K04L01M04L01R08L02M0803A2E02M08L02M08018C4K012402488K0J803004032E2J018,L0600FFC003198100FF04K04L01M04L01R08L02M080600302M08L02M0801044K01640368800140J807FC402022J018,L0601FFC0039B81019204K04I04001M04L01R08L02M0808I082M08L02M080104402FE01CC013080078080880554402022J018,L0601CJ01FB81011304K04007FC01M04L01R08L02M08L02M08L02M08019C4002O0801D00C388J04030E2J018,L0601CJ01FF810I104K0401D1701M04L01J04M08L02M0800ABC02M08L02M0800F84I04006003E88061007E0802F0401FC2J018,L0600CK07E01019B04K040300181M04L01I0CEM08L02M0800FF602M08L02M08J0400C401EC02B88079K0803184J02J018,L060BEA8L0100CE04K0404I041M04L010019BM08L02M0800C1B02M08L02M080408400820124I08800FI018804044J02J018,L061IFE0030C01K04K04L01M04L0100I1M08L02M080080902M08006D002M0805FC400820124I088003C00F0804044J02J018,L061IFC00F0F01K04K04036D801M04L0100131M08L02M080080902M0801FFC02M08J0400C601AC02588I0403A080404403FE2J018,L06L01F0F01005504K0403FFC01M04L01001B3M08L02M0800C3B02M080700702M0801004007C00F803F0800A00C208060C402002J018,L060033001C038101FF04K04L01M04L01I0E6M08L02M08007F202M080C00182M0801004001O0803F80E20803F8401002J018,L0600F1801801C1018004K04L01M04L01R08L02M080014002M08L02M0801FC4002201I01208060C03E080040401002J018,L0600E3C038018101I04K04003FC01M04L01I01N08L02M0808I082M08001I02M080124400FE018003788040400788J04J02J018,L0601C0C01801C101I04K04007D801M04L01I07EM08L02M080400302M0800FFE02M08J04008001FC024880404080880318402002J018,L060180C018038101D504K040044801M04L01001CAM08L02M080781602M0800C3702M0800FC4008L0248804940C008060C401C02J018,L0601C0E01E0B8101FF04K0400I401M04L0100103M08L02M0800FF802M080080902M0809A8400CI07003D8807FC078080404400302J018,L0600E1C00IF01002004K040064C01M04L0100101M08L02M080014002M080080902M080524400FE01D801108L0F0804044I0E2J018,L0600FFC007FE01K04K040036C01M04L0100101M08L02M08L02M0800C1B02M0801244K0104J08L0188060C4I012J018,L06007F8I0A801007C04K040013801M04L0100186M08L02M08L02M080077302M0801BC400300104J0807FC00F0803284J02J018,L06I04M0101CE04K04L01M04L01I0FEM08L02M08L02M08003E002M080010402F60184J0805540580801F04J02J018,L06003C8L01010304K040011001M04L01I01N08L02M08L02M08L02M08J04069200F8J08K0E008J0402922J018,L0600F98L01010104K040071801M04L01R08L02M08L02M080C00182M0805FC40492005001D0800EK08J0403FE2J018,L0600FDCL01010104K040040C01M04L0100BABM08L02M080047002M080600702M08J0402D6K0348803B8J08J0402002J018,L0601CCEL01018604K040040401M04L0100EFEM08L02M0800EF802M0803EBC02M08J04007C0FFC02488060CJ08J0401002J018,L06019CCL0100FE04K040040401M04L0100183M08L02M0800I802M08007F002M080FFC4K0AA8024880404J0804004J02J018,L0601ICL01001004K040061801M04L0100101M08L02M0800I802M08L02M0805944008L0350804040048803804J02J018,L0600DDCL01K04K04003F801M04L0100101M08L02M080098802M08L02M080104400CI0FC00F08060C0FF8800E04J02J018,L0600FFCL01056D04K04I04001M04I0400100187M08L02M0800F3002M08L02M080104400FE01A8J0803B80E008001C400102J018,L06007F8L010DFF04K04J0401M04007FC01I0FEM08L02M080023002M08L02M08019C4K01241FF88016003C08I02403FE2J018,L060014M01K04K040040C01M0401D1701I01N08L02001B4008L02M08L02M0800F040030012413288L0708J0402002J018,L06J04L01K04K040073801M040300181R08L02007FF008L02M08I02002M08J0400F601BC0208807A80018807FC401002J018,L0607E1CL0100C604K04001E001M0404I041I055M08L0201C01C08007F802M080067002M08J040092I0802088077C00708001C401002J018,L0607F7CL01018304K04I0C001M04L01001FFM08L0203I060800EB002M0800CD802M08J04009201I03388038003C0800304J02J018,L060F7F8L01010104K0402AD401M040055E0100192M08L02M080089002001B400800I802M08J0400D601C001E0800E00E10800E04J02J018,L060C3EM01010104K0403FFC01M04007FB0100113M08L02I04I0800I802007FF0080098802M0800984007C0078J08001C0FF8801804J02J018,L060E38M01018304K04L01M040060D8100I1M08L02003FF80800C980201C01C0800D9802M0801B4404K0CJ08001CJ0807204J02J018,L060C18M0100EE04K0404I041M0400404810019BM08L020030DC08006F80203I06080073002M0801244048I0FK0800700808807FC400822J018,L060C18M01007804K040200181M040040481I0CEM08L02002024080022002M08I02002M080164407BE018K0803800J8J0400822J018,L060FFBCL01K04K0403C0B01M040061D81R08L0200202408L02I04I08I08002M0801CC402D4L0E0806E80J804044J02J018,L060IFCL01008204K04007FC01M04003F901R08L0200306C08052A802003FF8080079002M08I084008L03B0807BC0J80J4I022J018,L060IFCL010DFF04K04I0A001M04I0A001I0FFM08L02001DCC0807FF8020030DC0800C9802M0800204003L02088K0J80J4I022J018,L06Q01004904K04L01M0404I041001C9M08L02I0F800800C10020020240800I802M0800E8400F6K02088K0FF880J4I022J018,L06Q0101I04K04L01M040200181001O08L02M0800818020020240800I802M0801A440092009803188K0AA880J4I022J018,L06Q0101I04K04L01M0403C0B01001O08L0203I0608008080200306C0800C9802M0801244009201B401F08N0807FC402AA2J018,L06Q01018004K04L01M04007FC01I08N08L0201800C0800C1802001DCC08007B002M0801A4400D60124002080I4J0802A8403FE2J018,L06Q0101FF04K04L01M04I0A001001FFM08L0200EAF808007F002I0F8008003E002M0800F84007C0124008080I4J0804004J02J018,L06Q01015504K04001F001I01I04L01001DBM08L02003FC0080034002M08L02M0800504K01CC1FF880I4J0804004I0A2J018,L06I048L01K04K04003B801001FF004L01R08L02M08L0203I020800CI02M0801004008I088021880I40028804004003C2J018,L0600FFCL01010104K040060C0100745C04L01I028M08L02M08002A80201800C08008I02M080100400CL0208806D400F080648400E82J018,L0600FFCL01010304K04004040100C00604L01I0FEM08L02M08007F80200EAF80800EA802M0801FC400FE01FC0208807FC03A0807FC403082J018,L0600DDCL0107FF04K04004040101I0104L0100187M08L02M0800C9002003FC00800FF802M0800A44M0C03F08K0C2080400403C82J018,L0601C8CL01034804K040060C01M04002300100101M08L02M080089802M08L02M08J04M0400A08K0F2080400400782J018,L06019CCL0101I04K04003B80100157804007780100101M08L02J0800800I802M08L02M0800F84M04J0807FC01E0804004001E2J018,L0601CCEL01K04K04001E001001FEC040044C0100103M08L020019C00800CD802M08007F802M08018C4K01FC03F88001C00788J0402022J018,L0600EFCL01015704K04L010018360400I401001C6M08L02003360080067002M0800FB002M0801044001I08002008003J08807F8403002J018,L0600EF8L0101FE04K04001100100101204004C401I07CM08L0200I2008L02M080089002M080104400F600200200800EK082018401E02J018,L06I028L01I0304K040071801001012040079801I01N08L020026200800CI02M0800I802M08018C4009201EC0200801800FF8820044003C2J018,L06Q01I0104K040040C01001876040011801R08L0200366008008I020019C00800C9802M0800F840092012403F88071I080810044I062J018,L06007FCL01I0104K040040401I0FE404L0100DFFM08L02001CC00800EA80200336008006D802M08J0400D601240110807FC00808I044003C2J018,L0600FFCL01016F04K040040401I02I04L0100I5M08L02M0800FF80200I20080027002M0809244007C01AC00408L08080558401602J018,L0601ED8L0101FE04K040061801M04037FC01R08L02M08L0200I2008L02M080FFC4I0800F801D0801040080807F0403802J018,L0601CN01K04K04003F801018003040155401I044M08L0200B6C008L02003660080080802M08J04002I04003488079C02A08I044J02J018,L0600CN01K04K04I0400100601C04L01I0C6M08L0201BFE00800AA802001CC0080081802M080054407FE02100248804700FF88I044J02J018,L0601CN010IF04K04L01003FF804L0100183M08L02M0800FF802I08800803FF802M0801FC40086033C02488044K08I044J02J018,L0616F6CL010AAF04K04037FC01I068004003FC0100101M08L02M08I01802M0801A4002M08012440082046403F08044J088I044J02J018,L061IFCL01I0E04K040155401M04007580100101M08L02I0D6008J0802I0AA008008I02M080124400820I400A0806D4I08805544I082J018,L061IFCL01003804K04L01M04004480100183M08L02001FE008J0802003FE008L02M0801B4400FC04C40100807FCI08807FC403FE2J018,L06Q0100E004K040040401M0400I401I0FEM08L020032400800AB802003J08007F802M08009840028068C1FF88M088J04035A2J018,L06002AAL0101C004K040040C01M040064C01I028M08L020022600800FF002002J0800E4802M08J04K031802188I040AA88I08401882J018,L0600FFCL0107I04K0401FFC01M040037C01R08L0200I2008L02002J08008I02M0801C04O02088003C0FF880378400682001818,L0600FFCL010F6D04K0400D5001J040040011001005B6M08I0800200336008L02003AA008008I02M0800704O0208800FK0806I400382007B18,L0601C4M010IF04K04004I01I0CE004L0100DFFM0800FF8020019C0080080802003FE008004I02M08I0C4O03F08079K080J4I082004918,L06018N01K04K04I080010019B0040040401R0803A2E02M0802D5802M0800FF802M0800784004CL0A0806100FF8804044I022004918,L0601CN01K04K04003C80100I1004016AC01R0806003020020200803FF002M0800ED802M0801C0400D6N0801D002488060C403E22006B18,L0600E24L01K04K040264C010013100401FF80100BABM0808I08200202008008I02I0D6008L02M08J040092I0C01F880078080080328402322003E18,L0600FFCL01K04K0403I401001B3004004I0100EFEM08L0200FFE008L02001FE0080039002M08J0400B2K03208I0C0C00801F0402122J018,L0601FFEL01K04K0401I401I0E6004004I0100183M0800ABC0200B54008002A802003240080079002M08J040066K02008K07808J04020E2004118,L060049M01K04K040064C01M04001A00100101M0800FF602002J0800FF8020022600800C9802M08J04K05FF82008031800F08J0401862015318,L06Q01007C04K04003F801I028004003F80100101M0800C1B02M0800C900200I200800I802M08006040038001083688060C00188J040082201FE18,L060CB6CL0100EE04K040016001I0FE0040060C0100187M080080902001FC00800898020033600800I802M0801EC400EC010483D88040400F08J04J02004018,L060DFFCL01018304K04L01001870040040401I0FEM0800809020039400800I8020019C00800CB002M08012440082010CJ080404058080254401F82I0418,L060DFFCL01010104K04002A401001010040040401I01N0800C3B020020600800CD802M08007F002M08012440082009801D08060C0E00807FC4030E2006F18,L06Q01010104K04007FF01001010040060C01R08007F202002020080067002003J08I08002M0801AC400C20060034880328J080700402022004918,L0600CN01018304K04006098100183004003B801I0FFM08001400200202008L02002J08L02M0800F84007C09600248801F00718800E0402022004918,L0601CN0100EE04K040040C81I0AE004001F001001F6M0808I0820030C008I02002003AA008007F802001FC008J0400280FFC03488K0DB0800384038E2007B18,L0601CN01007804K040040481I0FC004L0100112M080400302001FC0080067002003FE00800F6802007AF80804904O01F08K08C08I0C400F82002218,L0600FFCL01K04K040060D81M04004040100I1M080781602I02I0800CD802M08008I0201C00C080FFC402FEL0A08K0880800784I022I0818,L0601FFCL01005504K04003B90100101004016AC0100193M0800FF8020020200800I80200202008008I0203I0608010440254N08K088080180401C22003A18,L0600B58L010DFF04K04001E0010010100401FF801I0DBM08001400200202008009880200202008008I02M0801044008L01F08I040FF880754403622006918,L06Q01059204K04004I01007FF004004I01I04EM08L0200FFE00800D980200FFE008007680200155008018C4008001200318801840AA0807FC402122004918,L06007FM01091304K04004I01005AA004004I01R08L0200B54008007300200B5400800FF802003FF80800F8400C807FC02088M088J04021A2006918,L0600FF8L01091104K04006I01001J04L01R08L02002J08L02002J0800CI0200304C080040400FE040402088I080J80404403062003E18,L0600F7CL010D9B04K04007FC01M04L01R08L02M08L02M08008I0200206408J04K040403D9801BC0J82J401822001418,L0601C0EL0100CE04K040055401I0FF004L01R08L02M08L02M08008I0200202408J04002A060C033F801240J82J4J02004118,L060180CL01K04K04L01001F6004L01R080047002M08L02M0800D500200306C08J0404FE03F80040801240J81J403002004118,L0601C0EL01K04K04001C80100112004I01001J04M0800EF802M08L02M0800FF802001DC808J040492002001D0801AC0FE8804CC400C0201FF18,L0602D1CL0100C604K04003C80100I10040033801I0CEM0800I802M08L02M08L02I0FI080FFC4029200800348800C80DB8807FC400382004018,L061IFCL01018304K040064C01001930040066C010019BM0800I8020019C00800670020019C008L02M08J0400DA07FC02488N08J04I072004018,L061IFCL010101E4K0400I401I0DB00400I40100I1M0800988020033E00800CD8020033E00802DB002I0B6008J04004C04040348800EK0804004J02J018,L06092A4L010101A4K0400I401I04E004004C40100131M0800F300200I200800I80200I200806FF802003FE00800FC4K040401F0801ACJ080400400902J018,L06Q01018304K040065801M04006CC01001B3M08002300200I200800I80200I2008L02003J0801AC402A4060C00A080124J080400403FE2J018,L06007FM0100EE04K04003F8010018I040039801I0E6M08L020036600800D980200366008L02002J080124402FE03F8J080124001880648402022003A18,L0600FF8L01007804K04I04001001J04I01001J04M08L02001CC0080073002001CC00806DB002002J0801244K01401FF8801ACI06807FC402022006918,L0600EBCL01K04K04L01001D5004I08001I02N08007F802I0880080022002I08800807FF802001AA00801BC402480010132880078I0880400403062004918,L0600C0CL01005504K040035401001FF004003C801I0F2M0800EB002M08L02M08L02001FE008J0407FE00100208801J03880400401FC2004918,L060180CL0100FF04K04007FC01M040064C0100193M080089002I0AA008002A802I0AA008L02003J0800104008207FC02088010401E080400400202006A18,L0601C0CL01019204K04004I01M0400I40100I1M0800I802001FE008007F802001FE008007F802002J0801FC4008206100338807FC0F20800204J02001E18,L0601C1CL01011304K04004I0100IF00400I40100I1M0800C98020032400800C90020032400800FB002002J08I08400C6019001E0801I0C20807FC4J02J018,L0600FFCL010I104K04004I0100IA0040064C0100193M08006F802002260080089802002260080089002003J08I044007C007K0801I07A08001840292203FE18,L06007F8L01019B04K040076C0100183004003F801I0FEM08002200200I200800I80200I200800I802003FE008I044001I03K0800FC00E080030403FE202AB18,L06003EM0100CE04K04007FC01001010040016001I058M08L020033600800CD8020033600800C98020012400801FC4R0801A80038800E0402002004118,L06Q01K04K04L0100103004004I01001O08002A8020019C00800670020019C008006D802M0800404K0338J0801L080180401002004118,L06007F8L01K04K04I08001001AF004004I01001O0800FF802M08L02M08002700203I060801044K06EC0130801I0718807544J02006318,L0600FFCL0100FF04K04003C801I0FC004006I010018N0800CI02003J0800CI02003J08L0201801C0801044I040I40368801880DB0807FC4J02003E18,L0600E5CL0101ED04K040064C01M04007FC01001FFM08008I02002J08008I02002J08L0200FAF00807FC400DE0I40248801FC08C08J0403002J018,L0601C0EL0101I04K0400I401M04005540100155M08008I02003AA00800EA802003AA008L02001FC00801004009206EC02488K0880800A0400E02J018,L0601C0CL0101I04K0400I40100DFF004L01R0800EA802003FE00800FF802003FE008L02M0801004009203380398800E00880803F84001C2J018,L0600C0EL0101I04K040064C0100I5004L01R0800FF802M08L02M08L02M0800FC400D6L090801AC0FE88060C4I072J018,L060BEBCL0100ED04K04003F801M04003FC01I0FFM08L02M08L02M08I02002M08019040064L040801240DB8804044J02001C18,L061IFCL0101FF04K040016001I0280040075801001D6M0804J02002AA00800AA802002AA0080067002M0801004O03D880124J080404400F82007618,L061IFCL01018004K04L01I0FE004004480100112M0806B6802003FE00800FF802003FE00800CD802M0801004007L0248801A80B408060C403B42004118,L06Q0101I04K04L010018700400I40100I1M0802FF802J06008I01802J0600800I802I05I0801E8400D601280248800780EF080328402162004118,L06J0CL0101I04K04L01001010040064C0100193M08L02J02008J0802J020080098802001FC008019C4009201FC03588M08801F0402122006118,L06I07CL0101AA04K04L01001010040037C01I0DFM08I08002J02008J0802J0200800D98020030E008002040092I0401F0805ECI088J0403322003E18,L06001FCL0101FF04K04L01001830040011001I044M080079002002AE00800AB802002AE00800730020020200800E8400D4I04004080554I0880110401E02001418,L0600FEM01K04K04006I01I0A6004L01R0800C9802003FC00800FF002003FC008L020020200801A44003CI0C02008K0458807184J02J018,L0607FEM0101I04K04004I01I0FC0040031801I0C6M0800I802M08L02M08L020020600801244008001F8020080FF80FF080404400902017F18,L060F86M0101I04K040075401M040060C0100183M0800I802M08L02M08007F8020038C00801A44008L03F880AACJ080404403FE2J018,L060F8CM01018004K04007FC01I01I04004040100101M0800C98020175600805D58020175600800FB002I0F800800F8400C8007002A080104014080404402022004018,L060FEEM0101FF04K04L01I0FE004004040100101M08007B00201DFC008077F00201DFC0080089002I02I080050400FE01D8J08010407F080608402022004018,L0601FEM01009404K04I0A001001C60040060C0100183M08003E0020030600800C18020030600800I802M08J04K010401F08018C0C18803F8403062007618,L06007F8L01K04K04003F801001030040035801I0D6M08L020020200800808020020200800C980201BFE008018C4003801040318800F8080880040401FC2006D18,L06I0FCL01006804K040061C0100101004001F001I07CM08008080200202008008080200202008006D80200IA0080104400EC018402088K08088J0400202J018,L06I01CL0100FE04K04004040100183004L01R0800818020030E00800C38020030E0080027002M0801044008200F80208800E008188J04J02003F18,L06J04L01018304K04004040100IA004L01R0803FF802001FC008007F002001FC008008I02M08018C4008200500398801AC04B08J04J02026B18,L06Q01010104K040040C0100IF004007FC01001FFM0801A4002I02I08I08002I02I08008I0201FFE00800F8400C6L0E08012407E0800204J02034918,L06Q01010104K040071801M04022580100896M08008I02002J08008I02002J0800CI020155400800404007CN080124J0801F84J02004918,L06Q01018304K04001F001001J04030040100C01M08I08002002J08008I02002J0800FF8020030600801004002L01F8801A8020080608400C62006D18,L06Q0100EE04K04I02001001J04010040100401M08003F002003J0800CI02003J0800AA8020020200801004O0320800780FF8804044J02002618,L06Q01007C04K04L010018I04J0C01J03M0800E5002003FE00800FF802003FE008L020020600801FC407FE0FDC0200801J030804044J02J018,L06Q0108I04K04036D801001FF004007FC01001FFM08008180200124008004900200124008002A0020039E00801244K0AA80200801J06080404401DC2007F18,L06Q0109I04K0403FFC01I0920040076001001D8M080080802M08L02M08007F002I0F800800404O03D08019001C08061C403662002618,L06Q010D1004K04L01M04L01N05I080080802I0F8008003E002I0F800800C1802M0800EC4007E00FC0338801FC0300803F040J2I0118,L06Q010IF04K04L01I0550040011001I044007FE00800C3802001DC0080077002001DC0080080802I02I080124400D401AC00408K0EA88J040J2I0118,L06Q01014904K04003FC01001FF0040071801001C600D03808007F0020030600800C1802003060080080802001FC008012440092012401D0801540FF88I0C402662004F18,L06Q0101I04K04007D801001920040040D010010341800408I080020020200800808020020200800410020138E00801AC4009201240348801FF8I080078403FE2007A18,L06Q01K04K04004480100113004004068100101A2I0208008I020020200800808020020200807FF80201A0200800F8400DE01B40248801048808831D04J02J018,L06Q0100D504K0400I40100I1004004068100101AL0800CI020030600800C1802003060080I500200A0200800104I040098034880104K816104I022002618,L06Q0101FF04K040064C010019B004006180100186003FF008004I02001DC0080077002001DC008L02002060080380402M01F08018CK827104001E2006D18,L06Q0101I04K040036C01I0CE004003F801I0FE0035580800FF802I0FI08003C002I0FI08L020039400806C0403CI08800A0800F90J831F0400782004918,L06Q0101I04K040013801M04I04001I01I0306C080092002M08L02M0806FF802I0FC008044040078018CJ08001008988003C403C82005918,L06Q0101I04K0402J01M04J0401J0100202408L02J08008I02002J0800802AA802I02I0804404I06010403F8800440FF88I04403082007318,L06Q0101DB04K04038I010070C004I03C01J0F0020640801EI020047C008011F0020047C008L02J0800804404001E01840200801FC02008J0400E82I0218,L06Q0101FF04K0401FI0100606004001F001I07C0039EC08077I0201C66008071980201C6600804J0200E3C00806D4400FI0F80200801J020807F84003C2J018,L06Q01K04K04003C00100C03004007A001001E8001F8808061I0201846008061180201846008042I020186600807FC4038I0500200801I06308055C40206201FE18,L06Q01K04K04I078010080100403C200100F08M08041I0201042008041080201042008042I02010C6008J0402I010401F8801800C1880018402202I0318,L06Q010B6D04K04I01C0100801004030200100C08K0208041I0201002008040080201002008042I02010C20080200401I010C0320801FC080880060402202I0118,L06Q010IF04K04I0F80100C0300401F2001007C803800C08041I0201806008060180201806008042I02010C200801C0400EI0D002008K0808801C0402202I0118,L06Q01K04K04007C00100506004003E001I0F800C0580806BA80200C1C008030700200C1C00806B50020198600807004038I06002008K0C1880300402202I0118,L06Q01K04K0403EI01007FC004I07C01I01F007FE00807FF80200FF800803FE00200FF800807FF80200F0C00801C0400E009AC03A0807FC0770807FC403FE2015E18,L06Q01K04K0403J01I0A8004J0C01J03I05I08L020014I08005I020014I08L02004180080200401I0F7803788024802C080554402AA201F418,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L06Q01K04K04L01M04L01R08L02M08L02M08L02M08J04R08N08J04J02J018,L07mLF8,L07mLF8,,,,,,,,,,,,,,^XZ";
  // };

  const generateZPL = async () => {
    try {
      // Seleciona o elemento da tabela nutricional no modal
      const tableElement = document.getElementById('nutritional-table-print');

      if (!tableElement) {
        console.error('Tabela nutricional não encontrada.');
        return;
      }

      // Converte a tabela nutricional em uma imagem PNG
      const dataUrl = await toPng(tableElement);

      // Converte a data URL para um Blob
      const response = await fetch(dataUrl);
      const blob = await response.blob();

      // Converte o Blob para um objeto Image
      const image = await loadImage(URL.createObjectURL(blob));

      // Cria um canvas de 8x7cm (transformado em pixels, assumindo 81 DPI)
      const canvasWidth = LABEL_WIDTH;
      const canvasHeight = LABEL_HEIGHT;
      const canvas = createCanvas(canvasWidth, canvasHeight);
      const ctx = canvas.getContext('2d');

      // Preenche o canvas com um fundo branco
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvasWidth, canvasHeight);

      // Calcula as coordenadas para centralizar a imagem no canvas
      const x = (canvasWidth - image.height) / 2;
      const y = (canvasHeight - image.width) / 2;

      // Gira a imagem 90 graus para a esquerda e desenha no canvas
      ctx.translate(x + image.height / 2, y + image.width / 2);
      ctx.rotate(-Math.PI / 2);
      ctx.drawImage(image, -image.width / 2, -image.height / 2);

      // Converte o canvas para um Blob
      const rotatedBlob = await new Promise((resolve) => canvas.toBlob(resolve));

      // Cria um FormData para enviar a imagem para a API Labelary
      const formData = new FormData();
      formData.append('file', rotatedBlob, 'nutritional-table.png');

      // Envia a imagem para a API Labelary para converter em ZPL
      const labelaryResponse = await axios.post('https://api.labelary.com/v1/graphics', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const zplCode = labelaryResponse.data;
      // console.log('ZPL Code:', zplCode);

      // // Exibe um preview da imagem gerada
      // const previewUrl = URL.createObjectURL(rotatedBlob);
      // const previewImage = document.createElement('img');
      // previewImage.src = previewUrl;
      // previewImage.alt = 'Preview da Tabela Nutricional';
      // document.body.appendChild(previewImage);

      return zplCode;

    } catch (error) {
      console.error('Erro ao gerar o ZPL:', error);
    }
  };

  // Função de impressão ajustada com fallback imediato para erro de conexão
  const handlePrintLabel = async () => {
    setPrinting(true); // Mostrar a sobreposição de "Imprimindo..."
    setPrintStatus("Imprimindo...");

    try {
      const zplCode = await generateZPL();
      if (!zplCode) {
        throw new Error("Falha ao gerar o ZPL.");
      }

      // Preparar dados para salvar no histórico
      const printData = {
        recipeId,
        recipeName,
        clientName,
        fabricationDate,
        expirationDate,
        portionSize: modalPortionSize,
        allergensText,
        ingredients: editableIngredients,
        nutritionalSummary
      };

      // Modo de desenvolvimento - simular impressão
      const isDevelopment = process.env.NODE_ENV === 'development' || !window.BrowserPrint;
      
      if (isDevelopment) {
        // Simular impressão em desenvolvimento
        setPrintStatus("Simulando impressão (modo desenvolvimento)...");
        
        // Simular delay de impressão
        setTimeout(async () => {
          try {
            // Salvar no histórico após "impressão" simulada bem-sucedida
            await savePrintHistory(printData);
            setPrintStatus("Impressão simulada com sucesso! ✅");
            setTimeout(() => {
              setPrinting(false);
              setShowModal(false);
            }, 2000);
          } catch (error) {
            console.error("Erro ao salvar no histórico:", error);
            setPrintStatus("Erro ao salvar no histórico");
            setTimeout(() => setPrinting(false), 2000);
          }
        }, 1500); // Simula 1.5s de "impressão"
        
        return;
      }

      // Código original para produção com impressora real
      // Tentar obter a impressora padrão
      BrowserPrint.getDefaultDevice("printer", (printer) => {
        if (printer) {
          // Se a impressora padrão estiver definida, tentar enviar o comando ZPL
          printer.send(
            zplCode,
            async (success) => {
              // Salvar no histórico após impressão bem-sucedida
              await savePrintHistory(printData);
              setPrintStatus("Impressão bem-sucedida!");
              setTimeout(() => {
                setPrinting(false);
                setShowModal(false);
              }, 2000);
            },
            (error) => {
              handlePrinterError(error);
            }
          );
        } else {
          // Se não houver impressora padrão, descobrir todas as impressoras disponíveis
          BrowserPrint.getLocalDevices(
            (deviceList) => {
              const printer = deviceList.find((device) => device.deviceType === "printer");

              if (printer) {
                // Tentar enviar o comando ZPL
                printer.send(
                  zplCode,
                  async (success) => {
                    // Salvar no histórico após impressão bem-sucedida
                    await savePrintHistory(printData);
                    setPrintStatus("Impressão bem-sucedida!");
                    setTimeout(() => {
                      setPrinting(false);
                      setShowModal(false);
                    }, 2000);
                  },
                  (error) => {
                    handlePrinterError(error);
                  }
                );
              } else {
                setPrintStatus("Nenhuma impressora Zebra conectada. Verifique a conexão.");
                setTimeout(() => setPrinting(false), 2000);
              }
            },
            (error) => {
              // Capturar erro de conexão diretamente aqui
              handlePrinterError({ message: "ERR_CONNECTION_REFUSED" });
            }
          );
        }
      }, (error) => {
        // Capturar erro de conexão diretamente aqui
        handlePrinterError({ message: "ERR_CONNECTION_REFUSED" });
      });
    } catch (error) {
      handlePrinterError(error);
    }
  };

  // Função de tratamento de erros ajustada para lidar com falhas de conexão de forma eficiente
  const handlePrinterError = (error) => {
    console.error("Erro de impressão: ", error);
    let userMessage = "Ocorreu um erro desconhecido.";

    if (error && error.message) {
      const errorMessage = error.message;

      // Verificações de erros comuns
      if (errorMessage.includes("ERR_CONNECTION_REFUSED")) {
        userMessage = "Erro de conexão. Verifique se o software da Zebra está instalado e a impressora está conectada.";
      } else if (errorMessage.includes("paperOut")) {
        userMessage = "A impressora está sem papel.";
      } else if (errorMessage.includes("ribbonOut")) {
        userMessage = "A impressora está sem ribbon.";
      } else if (errorMessage.includes("headOpen")) {
        userMessage = "A cabeça de impressão está aberta. Feche-a para continuar.";
      } else if (errorMessage.includes("paused")) {
        userMessage = "A impressora está pausada. Verifique o painel.";
      }
    }

    setPrintStatus(userMessage); // Atualiza a mensagem de status
    setTimeout(() => setPrinting(false), 3000); // Remove o overlay de "Imprimindo" após o erro
  };

  const handleSaveIngredients = (selectedIngredients) => {
    const db = getDatabase();
    const recipeRef = dbRef(db, `recipes/${recipeId}`);
    const updatedIngredients = { ...recipe.ingredients };

    selectedIngredients.forEach((ingredient) => {
      updatedIngredients[ingredient.id] = ingredient.quantity || 0;
    });

    update(recipeRef, { ingredients: updatedIngredients });
    setIngredients(Object.keys(updatedIngredients));
    setNewIngredients([]); // Limpa os novos ingredientes após salvar
    setIsModalOpen(false);
  };

  const handleDeleteIngredient = (ingredientId) => {
    if (window.confirm("Tem certeza de que deseja excluir este ingrediente? Esta ação é irreversível.")) {
      const db = getDatabase();
      const recipeRef = dbRef(db, `recipes/${recipeId}`);
      
      // Atualiza localmente primeiro
      const updatedIngredients = ingredients.filter(ingredient => ingredient.id !== ingredientId);
      
      // Atualiza no Firebase
      update(recipeRef, { ingredients: updatedIngredients })
        .then(() => {
          setIngredients(updatedIngredients); // Atualiza o estado local
        })
        .catch((error) => {
          console.error("Erro ao excluir o ingrediente: ", error);
          alert("Erro ao excluir o ingrediente. Tente novamente.");
        });
    }
  };

  // Reference values based on a 2000 kcal diet
  const referenceValues = {
    energy: 2000, // kcal
    proteins: 50, // g
    carbohydrates: 300, // g
    dietaryFiber: 25, // g
    totalFats: 70, // g
    addedSugars: 50, // g
    saturatedFats: 20, // g
    transFats: 0, // g (no recommended intake)
    sodium: 2400, // mg
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const storage = getStorage();
    const storageReference = storageRef(storage, `recipes/${recipeId}/picture`);
    try {
      await uploadBytes(storageReference, file);
      const downloadURL = await getDownloadURL(storageReference);

      const db = getDatabase();
      const recipeRef = dbRef(db, `recipes/${recipeId}`);
      await update(recipeRef, { photo: downloadURL });

      setRecipe((prev) => ({ ...prev, photo: downloadURL }));
      alert("Imagem carregada com sucesso!");
    } catch (error) {
      console.error("Erro ao carregar a imagem: ", error);
      alert("Erro ao carregar a imagem. Tente novamente.");
    }
  };

  return (
    <IngredientsRoot>
      <FunctionsHeader />
      <Breadcrumb path={`Página inicial > Receitas > ${recipe?.description || "Carregando..."}`} />
      <MainContent>
        <ContentWrapper>
          <Column>
            <RecipeImage src={recipe?.photo || "/default-recipe-image.webp"} alt={recipe?.description} />
            <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} id="upload-image" />
            <Button onClick={() => document.getElementById('upload-image').click()}>Alterar imagem da receita</Button>
            
            <h2 style={{ marginTop: '20px', marginBottom: '15px' }}>Instruções de Preparo</h2>
            {editingInstructions ? (
              <div style={{ marginBottom: '20px' }}>
                <textarea
                  value={recipeInstructions}
                  onChange={(e) => setRecipeInstructions(e.target.value)}
                  placeholder="Insira as instruções de preparo da receita..."
                  style={{
                    width: 'calc(100% - 26px)', // Subtrai padding e border
                    minHeight: '120px',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    boxSizing: 'border-box'
                  }}
                />
                <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                  <Button onClick={saveRecipeInstructions}>
                    Salvar
                  </Button>
                  <Button onClick={() => setEditingInstructions(false)} style={{ backgroundColor: '#6c757d' }}>
                    Cancelar
                  </Button>
                </div>
              </div>
            ) : (
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef',
                  borderRadius: '8px',
                  padding: '12px',
                  minHeight: '80px',
                  fontSize: '14px',
                  lineHeight: '1.5'
                }}>
                  {recipeInstructions || "Nenhuma instrução de preparo adicionada ainda."}
                </div>
                <Button onClick={() => setEditingInstructions(true)} style={{ marginTop: '10px' }}>
                  {recipeInstructions ? 'Editar Instruções' : 'Adicionar Instruções'}
                </Button>
              </div>
            )}
          </Column>
          <Column>
            <h2>{recipe?.description || "Carregando..."}</h2>
            <IngredientsTable>
              <thead>
                <tr>
                  <th>Ingrediente</th>
                  <th>Quantidade (g/ml)</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(ingredients) && ingredients.map((ingredient, index) => (
                  <tr key={ingredient.id}>
                    <td>{ingredient.name}</td>
                    <td>{formatNumberWithComma(ingredient.quantity_g_or_ml)}</td>
                    <td>
                      <ActionButtons>
                        <IconButton 
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedIngredient(ingredient);
                          }}
                          title="Ver informação nutricional"
                        >
                          <InfoIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => handleDeleteIngredient(ingredient.id)}
                          title="Excluir ingrediente"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ActionButtons>
                    </td>
                  </tr>
                ))}
              </tbody>
            </IngredientsTable>
            <Button onClick={() => setIsModalOpen(true)}>Adicionar Ingredientes</Button>
          </Column>
          <Column>
            <NutritionalTable>
              <thead>
                <tr>
                  <th colSpan="4" className="center">{recipe?.description || "Receita"}</th>
                </tr>
                <tr>
                  <th colSpan="4" className="sub-header">Informação Nutricional/Porção de {portionSize}g (1 unidade)</th>
                </tr>
                <tr>
                  <th></th>
                  <th>100g</th>
                  <th>{portionSize}g</th>
                  <th>% VD*</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Valor energético (kcal)</td>
                  <td>{((nutritionalSummary.energy * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.energy || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.energy || 0) / referenceValues.energy) * 100)}</td>
                </tr>
                <tr>
                  <td>Carboidratos (g)</td>
                  <td>{((nutritionalSummary.carbohydrates * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.carbohydrates || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.carbohydrates || 0) / referenceValues.carbohydrates) * 100)}</td>
                </tr>
                <tr>
                  <td>Açúcares totais (g)</td>
                  <td>{((nutritionalSummary.totalSugars * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.totalSugars || 0).toFixed(1).replace('.', ',')}</td>
                  <td>**</td>
                </tr>
                <tr>
                  <td>Açúcares adicionados (g)</td>
                  <td>{((nutritionalSummary.addedSugars * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.addedSugars || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.addedSugars || 0) / referenceValues.addedSugars) * 100)}</td>
                </tr>
                <tr>
                  <td>Proteínas (g)</td>
                  <td>{((nutritionalSummary.proteins * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.proteins || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.proteins || 0) / referenceValues.proteins) * 100)}</td>
                </tr>
                <tr>
                  <td>Gorduras totais (g)</td>
                  <td>{((nutritionalSummary.totalFats * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.totalFats || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.totalFats || 0) / referenceValues.totalFats) * 100)}</td>
                </tr>
                <tr>
                  <td>Gorduras saturadas (g)</td>
                  <td>{((nutritionalSummary.saturatedFats * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.saturatedFats || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.saturatedFats || 0) / referenceValues.saturatedFats) * 100)}</td>
                </tr>
                <tr>
                  <td>Gorduras trans (g)</td>
                  <td>{((nutritionalSummary.transFats * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.transFats || 0).toFixed(1).replace('.', ',')}</td>
                  <td>**</td>
                </tr>
                <tr>
                  <td>Fibras alimentares (g)</td>
                  <td>{((nutritionalSummary.dietaryFiber * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{(nutritionalSummary.dietaryFiber || 0).toFixed(1).replace('.', ',')}</td>
                  <td>{Math.round(((nutritionalSummary.dietaryFiber || 0) / referenceValues.dietaryFiber) * 100)}</td>
                </tr>
                <tr>
                  <td>Sódio (mg)</td>
                  <td>{Math.round(nutritionalSummary.sodium * 100 / portionSize)}</td>
                  <td>{Math.round(nutritionalSummary.sodium || 0)}</td>
                  <td>{Math.round(((nutritionalSummary.sodium || 0) / referenceValues.sodium) * 100)}</td>
                </tr>
                <tr>
                  <td colSpan="4" className="footer-note">*Percentual de valores diários fornecidos pela porção.</td>
                </tr>
                <tr>
                  <td colSpan="4" className="footer-note">*Valores diários de referência com base em uma dieta de 2000 kcal ou 8400 kj. Seus valores diários podem ser maiores ou menores dependendo de suas necessidades energéticas.</td>
                </tr>
                <tr>
                  <td colSpan="4" className="footer-note">Ingredientes: {Array.isArray(ingredientNames) ? ingredientNames.join(', ') : ''}</td>
                </tr>
                <tr>
                  <td colSpan="4" className="footer-note-bold" dangerouslySetInnerHTML={{ __html: allergensText }}></td>
                </tr>
              </tbody>
            </NutritionalTable>
            
            <Button onClick={openModal}>Imprimir Rótulo Nutricional</Button>

            {showModal && (
              <Modal>
                <ModalContent>
                  {step === 1 ? (
                    <div>
                      <h3>Preencha os dados</h3>
                      {location.state?.isReprint && (
                        <InfoBalloon style={{ backgroundColor: '#e8f5e8', color: '#2d5a2d' }}>
                          🔄 <strong>Reimpressão:</strong> Os dados foram pré-preenchidos do histórico. Você pode editá-los antes de imprimir.
                        </InfoBalloon>
                      )}
                      <InfoBalloon>
                        Esta funcionalidade foi desenvolvida e testada para impressoras da marca Zebra. A impressão só acontecerá
                        se este sistema conseguir se comunicar com o software de impressão do fabricante, devidamente instalado no computador ao qual a impressora está conectada.
                      </InfoBalloon>
                      {(process.env.NODE_ENV === 'development' || !window.BrowserPrint) && (
                        <InfoBalloon style={{ backgroundColor: '#fff3cd', color: '#856404', borderLeft: '5px solid #ffc107' }}>
                          🧪 <strong>Modo Desenvolvimento:</strong> A impressão será simulada para testes. O histórico será salvo normalmente.
                        </InfoBalloon>
                      )}
                      <InputField
                        type="text"
                        value={recipeName}
                        onChange={(e) => setRecipeName(e.target.value.slice(0, 50))}
                        placeholder="Nome da Receita"
                        maxLength={50}
                      />
                      <CharacterCounter>{50 - recipeName.length} caracteres restantes</CharacterCounter>
                      <InputField
                        type="text"
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                        placeholder="Nome do Cliente"
                      />
                      <label>Data de Fabricação</label>
                      <InputField
                        type="date"
                        value={fabricationDate}
                        onChange={(e) => setFabricationDate(e.target.value)}
                      />
                      <label>Data de Validade</label>
                      <InputField
                        type="date"
                        value={expirationDate}
                        onChange={(e) => setExpirationDate(e.target.value)}
                      />
                      <label>Tamanho da Porção (g)</label>
                      <InputField
                        type="number"
                        value={modalPortionSize}
                        onChange={(e) => setModalPortionSize(e.target.value)}
                      />
                      <InfoBalloon style={{ marginTop: '4px', fontSize: '11px' }}>
                        Este campo ajusta apenas a apresentação da porção na etiqueta impressa. 
                        Não altera as quantidades dos ingredientes ou os cálculos nutricionais da receita.
                      </InfoBalloon>
                       <label>Ingredientes</label>
                      <InputField
                        type="text"
                        value={editableIngredients}
                        onChange={(e) => setEditableIngredients(e.target.value)}
                      />
                      <label>Texto dos Alérgenos</label>
                      <InputField
                        type="text"
                        value={allergensText}
                        onChange={(e) => setAllergensText(e.target.value)}
                      />
                      <ModalActions>
                        <Button onClick={handleCloseModal}>Fechar</Button>
                        <Button onClick={handleAdvance}>Avançar</Button>
                      </ModalActions>
                    </div>
                  ) : (
                    <div>
                      <h2>Confirme os dados para impressão</h2>
                      {/* Display the full nutritional table */}
                      <NutritionalTablePrintScreen id="nutritional-table-print" style={tableStyle}>
                        <thead>
                          <tr>
                            <th colSpan="4" className="center" style={cellStyle}>{recipeName || "Receita"}</th>
                          </tr>
                          <tr>
                            <th colSpan="4" className="sub-header" style={cellStyle}>Informação Nutricional/Porção de {modalPortionSize}g (1 unidade)</th>
                          </tr>
                          <tr>
                            <th style={cellStyle}></th>
                            <th style={cellStyle}>100g</th>
                            <th style={cellStyle}>{modalPortionSize}g</th>
                            <th style={cellStyle}>% VD*</th>
                          </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td style={cellStyle}>Valor energético (kcal)</td>
                          <td style={cellStyle}>{((nutritionalSummary.energy * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.energy || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.energy || 0) / referenceValues.energy) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Carboidratos (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.carbohydrates * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.carbohydrates || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.carbohydrates || 0) / referenceValues.carbohydrates) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Açúcares totais (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.addedSugars * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.addedSugars || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.addedSugars || 0) / referenceValues.addedSugars) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Açúcares adicionados (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.addedSugars * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.addedSugars || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.addedSugars || 0) / referenceValues.addedSugars) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Proteínas (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.proteins * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.proteins || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.proteins || 0) / referenceValues.proteins) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Gorduras totais (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.totalFats * 100 / portionSize) || 0).toFixed(1).replace('.', ',') || 0}</td>
                          <td style={cellStyle}>{nutritionalSummary.totalFats.toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.totalFats || 0) / referenceValues.totalFats) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Gorduras saturadas (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.saturatedFats * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.saturatedFats || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.saturatedFats || 0) / referenceValues.saturatedFats) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Gorduras trans (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.transFats * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{(nutritionalSummary.transFats || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>**</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Fibras alimentares (g)</td>
                          <td style={cellStyle}>{((nutritionalSummary.dietaryFiber * 100 / portionSize) || 0).toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{nutritionalSummary.dietaryFiber.toFixed(1).replace('.', ',')}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.dietaryFiber || 0) / referenceValues.dietaryFiber) * 100)}</td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Sódio (mg)</td>
                          <td style={cellStyle}>{Math.round(nutritionalSummary.sodium * 100 / portionSize)}</td>
                          <td style={cellStyle}>{Math.round(nutritionalSummary.sodium || 0)}</td>
                          <td style={cellStyle}>{Math.round(((nutritionalSummary.sodium || 0) / referenceValues.sodium) * 100)}</td>
                        </tr>
                          <tr>
                            <td style={cellStyle} colSpan="4" className="footer-note">*Percentual de valores diários fornecidos pela porção.</td>
                          </tr>
                          <tr>
                            <td style={cellStyle} colSpan="4" className="footer-note">*Valores diários de referência com base em uma dieta de 2000 kcal ou 8400 kj. Seus valores diários podem ser maiores ou menores dependendo de suas necessidades energéticas.</td>
                          </tr>
                          <tr>
                            <td style={cellStyle} colSpan="4" className="footer-note">Ingredientes: {editableIngredients}</td>
                          </tr>
                          <tr>
                            <td style={cellStyle} colSpan="4" className="footer-note-bold" dangerouslySetInnerHTML={{ __html: allergensText }}></td>
                          </tr>
                          <tr>
                            <td style={cellStyle} colSpan="4" className="footer-note-bold">FAB: {formatDate(fabricationDate)} &emsp; VAL: {formatDate(expirationDate)}</td>
                          </tr>
                          <tr>
                            <td style={cellStyle} colSpan="4" className="client-name">{clientName}</td>
                          </tr>
                        </tbody>
                      </NutritionalTablePrintScreen>
                      <ModalActions>
                        <Button onClick={handleGoBack}>Voltar</Button>
                        <Button onClick={handlePrintLabel}>Confirmar e Imprimir</Button>
                      </ModalActions>
                    </div>
                  )}
                </ModalContent>
              </Modal>
            )}
          </Column>
        </ContentWrapper>
      </MainContent>
      {isModalOpen && (
        <SelecionarIngredientesModal
          onClose={() => setIsModalOpen(false)}
          onSave={handleSaveIngredients}
          selectedIngredients={ingredients}
          newIngredients={newIngredients}
          setNewIngredients={setNewIngredients}
          recipeId={recipeId}
        />
      )}

      {printing && (
        <PrintingOverlay>
          <LoaderIcon />
          <p>{printStatus}</p>
        </PrintingOverlay>
      )}
      {selectedIngredient && (
        <IngredientNutritionalModal
          ingredient={selectedIngredient}
          onClose={() => setSelectedIngredient(null)}
        />
      )}
    </IngredientsRoot>
  );
};

export default IngredientesDaReceita;